<template>
  <div class="base-attendees-text">
    <span>with</span>
    <BaseCompactAttendees :attendees="attendees" size="micro" />
    <span class="organizer">{{ organizer }}</span>
    <span>{{ others }}</span>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from "vue";

import { Attendee } from "@ctrl/controller-rpc";

import BaseCompactAttendees from "@/components/base/BaseCompactAttendees.vue";

export default defineComponent({
  components: { BaseCompactAttendees },
  props: {
    attendees: {
      type: Object as PropType<Array<Attendee>>,
      required: true,
    },
    organizer: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { attendees } = toRefs(props);
    const others = computed(
      () =>
        `and ${attendees.value.length - 1} other${
          attendees.value.length > 2 ? "s" : ""
        }`
    );
    return { others };
  },
});
</script>
<style scoped lang="scss">
.base-attendees-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  @extend %font-body-regular;
  @include themed() {
    color: t($grey-40);
  }
  .organizer {
    @include themed() {
      color: t($primary);
    }
  }
}
</style>
